module.exports = __webpack_public_path__ + "static/media/S (129).b875d025.jpg";